module.exports = __webpack_public_path__ + "static/media/TikTok.910ec69c.svg";